import { Divider } from '@material-ui/core';
import { Checkbox } from 'formik-material-ui';
import CheckIcon from '@material-ui/icons/Check';
import { Field } from 'formik';
import React from 'react';
import styled from 'styled-components';

const EditIconContainer = styled.div`
    padding-left:10px;
    padding-right:10px;
`;

const OuterContainer = styled.div`
    width:100%
    &:hover {
        background:#E8E8E8;
    }    
    &:not(:hover) ${EditIconContainer} {
        display: none;
      }    
`;

const Container = styled.div`
    width:100%
    padding-left:20px;
    padding-right:20px;
    display:grid;
    grid-template-columns:100px 400px 200px 100px;
    align-items:center;
    min-height:65px; 
`;

const SubContainerA = styled.div`
display:flex;
flex-direction:column;
justify-content:center; 
`;

const SubContainerA1 = styled.div`
text-align: left;
font-size: 15px;
font-weight:500;
font-family: "Roboto";
`;

const SubContainerA2 = styled.div`
text-align: left;
font-size:13px
font-family: "Roboto";
font-weight:400; 
`;

const SubContainerB = styled.div`
      display:flex;
      align-items:center;
      justify-content:space-between;
      height:60px;
`;
const CorpContainer = styled.div`
text-align: left;
font-size: 15px;
font-weight:500;
font-family: "Roboto", "Helvetica", "Arial", sans-serif;
color:#304a57;
display:flex;
align-items:center;
`;
const ProcedureCountContainer = styled.div`
text-align: left;
font-size: 15px;
font-family: "Roboto";
display:flex;
align-items:center;
`;

const Type = styled.div`
`;

const DeleteStep = styled.div`
    font-size:24px;
`;

const LoadProceduresItem = ({ category, fieldName, gbus }) => {
    const importFieldName = `${fieldName}.import`
    return (
        <OuterContainer>
            <Container >
                <Field
                    component={Checkbox}
                    type="checkbox"
                    edge="start"
                    name={importFieldName}
                    tabIndex={-1}
                    disableRipple
                />
                <SubContainerA>
                    <SubContainerA1>
                        {category.name}
                    </SubContainerA1>
                    <SubContainerA2>
                        {category.description}
                    </SubContainerA2>
                </SubContainerA>
                <SubContainerB>
                    <CorpContainer>
                        {category.isCorporate &&
                            <>
                                <CheckIcon color="primary" />
                                <div style={{ paddingLeft: 10 }}>Corporate</div>
                            </>
                        }
                        {(Number(category.gbuId && category.gbuId) > 0) && gbus &&
                            <>
                                <CheckIcon color="primary" />
                                <div style={{ paddingLeft: 10 }}>GBU({gbus.find(x => x.id === category.gbuId).name})</div>
                            </>
                        }
                    </CorpContainer>
                </SubContainerB>
                <SubContainerB>
                    <ProcedureCountContainer>
                        <div >{`${category.functionProcedureCount} Procedure${category.functionProcedureCount === 1 ? '' : 's'}`}</div>
                    </ProcedureCountContainer>
                </SubContainerB>
                <div style={{ paddingTop: 1 }} />
            </Container>
            <Divider />
        </OuterContainer>
    )
}
export default LoadProceduresItem;